var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header",attrs:{"data-toggle":"collapse","data-target":'#' + _vm.divid,"aria-expanded":"false","aria-controls":'#' + _vm.divid}},[_vm._v(" "+_vm._s(_vm.sectionName)+" ")]),_c('div',{staticClass:"card-body collapse show",attrs:{"id":_vm.divid}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }